import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Navigation from './components/ui/Navigation';
import AlertsContainer from './containers/ui/AlertsContainer';
import TopBar from './components/ui/TopBar'
import AuthorizationEverybody from './containers/users/AuthorizationEverybody';
import AuthorizationUser from './containers/users/AuthorizationUser';
import AuthorizationAdmin from './containers/users/AuthorizationAdmin';
import { withRouter } from './actions/withRouterHook'
import CacheBuster from './CacheBuster';
import { recoverLogin } from './actions/userActions'
import './styles/css/custom.css'
import "react-datepicker/dist/react-datepicker.css"

class App extends React.Component {

    shouldComponentUpdate(nextProps, nextAction) {
        if (nextProps.loggedIn !== this.props.loggedIn) {
            return true
        } else {
            return false
        }
    }

    componentDidMount() {
         if (localStorage.getItem('jwt_token') !== null && this.props.loggedIn === false) {
            this.props.recoverLogin()
        }
    }
    
    render() {
        return (
            <div className="wrapper">
                {(window.location.pathname  === "/" && !this.props.loggedIn) || (window.location.pathname  === "/databasefunctions") ? null : <Navigation />}
                {(window.location.pathname  === "/" && !this.props.loggedIn) ? null : <TopBar />}
                <AlertsContainer />
                <CacheBuster>
                    {() => {
                        console.log('loadingApp');
                        return (
                            <div className="main">
                                <Routes>
                                    <Route exact path="/" element={<AuthorizationEverybody toRender='home' />} />
                                    <Route exact path="/welcome" element={<AuthorizationUser toRender='welcome' />} />
                                    <Route exact path="/myuser" element={<AuthorizationUser toRender='user' />} />
                                    <Route exact path="/confirmemail/:id/:code/*" element={<AuthorizationEverybody toRender='confirmemail' />} />
                                    <Route exact path="/help" element={<AuthorizationEverybody toRender='help' />} />
                                    <Route exact path="/about" element={<AuthorizationEverybody toRender='about' />} />
                                    <Route exact path="/terms" element={<AuthorizationEverybody toRender='terms' />} />
                                    <Route exact path="/privacy" element={<AuthorizationEverybody toRender='privacy' />} />
                                    <Route exact path="/login" element={<AuthorizationEverybody toRender='login' />} />
                                    <Route exact path="/login-microsoft" element={<AuthorizationEverybody toRender='login-microsoft' />} />
                                    <Route exact path="/login-pepsi2" element={<AuthorizationEverybody toRender='login-pepsi' />} />
                                    <Route exact path="/presentations" element={<AuthorizationUser toRender='presentations' />} />
                                    <Route exact path="/presentations/powerpoint/:id" element={<AuthorizationUser toRender='specific-slide' />} />
                                    <Route exact path="/presentations/powerpoint/:id/slides/:slideId" element={<AuthorizationUser toRender='specific-slide' />} />
                                    <Route exact path="/presentations/powerpoint/:id/download" element={<AuthorizationUser toRender='specific-slide' />} />
                                    <Route exact path="/presentations/excel/:id" element={<AuthorizationUser toRender='specific-excel' />} />
                                    <Route exact path="/presentations/excel/:id/download" element={<AuthorizationUser toRender='specific-excel' />} />
                                    <Route exact path="/presentations/excel/:id/sheets/:sheetID" element={<AuthorizationUser toRender='specific-excel' />} />
                                    <Route exact path="/admin" element={<AuthorizationAdmin toRender='admin' />} />
                                    <Route exact path="/statistics" element={<AuthorizationAdmin toRender='statistics' />} />
                                    <Route exact path="/databasefunctions" element={<AuthorizationAdmin toRender='functions' />} />
                                </Routes>
                            </div>
                        );
                    }}
                </CacheBuster>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        userID: state.users.userID,
        role: state.users.role,
        loggedIn: state.users.loggedIn,
        loading: state.ui.loading,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ recoverLogin }, dispatch)
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))